import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { COUPON_CATEGORY_DETAIL_QUERY } from "../../Queries";
import Presenter from "./Presenter";

const Container = withRouter(({ history, match, location }) => {
  const { data, loading } = useQuery(COUPON_CATEGORY_DETAIL_QUERY, {
    variables: { id: match.params.id },
  });

  if (loading === true) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  } else if (!loading && data && data.AdminCouponCategoryDetail) {
    const {
      AdminCouponCategoryDetail: { id, name },
    } = data;
    return (
      <Presenter
        history={history}
        match={match}
        location={location}
        id={id}
        name={name}
      ></Presenter>
    );
  }
});

export default Container;
